import { AfterViewChecked, Component, Input } from '@angular/core';
import { OverlaySpinner } from '../../models/common.model';
import { OVERLAY_SPINNER_ID } from '../../models/constants';

@Component({
  selector: 'app-overlay-spinner',
  templateUrl: './overlay-spinner.component.html',
  styleUrls: ['./overlay-spinner.component.scss'],
})
export class OverlaySpinnerComponent implements AfterViewChecked {
  OVERLAY_SPINNER_ID = OVERLAY_SPINNER_ID;
  @Input() loadingAriaLabel: string = OverlaySpinner.ARIA_LABEL;
  @Input() isLoading = false;
  @Input() focusOnLoading = true;

  ngAfterViewChecked(): void {
    if (this.isLoading && this.focusOnLoading && document.activeElement.id !== OVERLAY_SPINNER_ID) {
      document.getElementById(OVERLAY_SPINNER_ID)?.focus();
    }
  }
}
